<div class="ticket">
  <div class="laoding" *ngIf="isShowLoading">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  </div>
  <div class="ticketInfo">
    <div class="header">
      <div class="ticketTitle mr50">
        <div class="back mr10" (click)="back()">
          <div class="backInco"></div>
        </div>{{'ticket.ticketTitle' | translate}}
      </div>
      <!-- Hidden: View Logs button -->
      <!-- <div class="logInfo cursor mr50" (click)="showLogs()" *ngIf="ticketStatusID != ticketStatusEnum['create'] && isSupport">
        {{'ticket.gotologs' | translate}}
      </div> -->
      <button mat-raised-button color="primary" (click)="copyLink()" *ngIf="ticketStatusID != 0" class="mr20">{{'ticket.copyLink' | translate}}</button>
    </div>
    <form class="mt40" [formGroup]="ticketForm">
      <nz-form-item *ngIf="ticketStatusID !=  0 && !isShowLoading">
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.ticketNo' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('ticketNo')?.value}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.fullName' | translate}}</div>
            <div class="labelContent">{{ticketInfo?.submittedByName || ticketInfo?.ticket?.submittedBy}}</div>
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="ticketStatusID == ticketStatusEnum['create'] && !isShowLoading">
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.email' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('email')?.value}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.fullName' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('fullName')?.value}}</div>
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="ticketStatusID != ticketStatusEnum['create'] && !isShowLoading">
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.fullName' | translate}}</div>
            <div class="labelContent">{{ticketInfo?.submittedByName || ticketInfo?.ticket?.submittedBy}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="12">
          <nz-form-control [nzSpan]="12">
            <div class="labelInfo">
              <div class="labelName">{{'ticket.submittedDate' | translate}}</div>
              <div class="labelContent">{{ticketForm.get('submittedDate')?.value | date:'dd/MM/yyyy HH:mm'}}</div>
            </div>
          </nz-form-control>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport">
        <nz-form-control [nzSpan]="12" class="relative">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.contact' | translate}}</mat-label>
            <input matInput formControlName="contactNo" required
              oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')"  >
            <mat-error *ngIf="ticketForm.get('contactNo')?.hasError('required')">{{'input.contact' |
              translate}}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" *ngIf="ticketStatusID != ticketStatusEnum['submitted']">
          <div class="cctoemail w500" [ngClass]="{'clickEmail':isClickEmail,'mousemoveEmail':isMousemoveEmail}"
            (click)="clickFunction()" (blur)="blurFunction()" (mousemove)="mousemoveFunction()"
            (mouseleave)="mouseleaveFunction()" tabindex="0">
            <nz-select class="w500 h100" nzMode="tags" nzPlaceHolder="{{'ticket.ccToEmial' | translate}}"
              formControlName="emailCC" [nzBorderless]="true">
              <nz-option *ngFor="let option of ccEmailList" [nzLabel]="option" [nzValue]="option"></nz-option>
            </nz-select>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" *ngIf="ticketStatusID != ticketStatusEnum['create']">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.status' | translate}}</div>
            <div class="labelContent">{{getStatus(ticketStatusID)}}</div>
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport">
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.contact' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('contactNo')?.value}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.status' | translate}}</div>
            <div class="labelContent">{{getStatus(ticketStatusID)}}</div>
          </div>
        </nz-form-control>
      </nz-form-item>
      <!-- <nz-form-item>
        <nz-form-control [nzSpan]="12" class="relative" *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.courseLecturer' | translate}}</mat-label>
            <input matInput formControlName="courseLecturer" required>
            <mat-error *ngIf="ticketForm.get('courseLecturer')?.hasError('required')">{{'input.courseLecturer' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" class="relative"
          *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.courseLecturer' | translate}}</mat-label>
            <input matInput formControlName="courseLecturer">
          </mat-form-field>
        </nz-form-control>
      </nz-form-item> -->
      <nz-form-item>
        <nz-form-control [nzSpan]="12" class="relative" *ngIf="ticketStatusID == ticketStatusEnum['create'] && isSupport">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.problemCategory' | translate}}</mat-label>
            <mat-select formControlName="categoryID" required (selectionChange)="onCategoryChange($event)">
              <mat-option *ngFor="let option of problemCategoryList" [value]="option.id">
                {{lang == "en" ? option.categoryDescrEng : option.categoryDescrChi}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ticketForm.get('categoryID')?.hasError('required')">{{'input.category' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" class="relative"
          *ngIf="ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.problemCategory' | translate}}</mat-label>
            <mat-select formControlName="categoryID" required [disabled]="true" (selectionChange)="onCategoryChange($event)">
              <mat-option *ngFor="let option of problemCategoryList" [value]="option.id">
                {{lang == "en" ? option.categoryDescrEng : option.categoryDescrChi}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ticketForm.get('categoryID')?.hasError('required')">{{'input.category' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" *ngIf="ticketStatusID == ticketStatusEnum['submitted'] && isSupport || ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel']">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.ccToEmial' | translate}}</div>
            <div class="labelContent">{{showEmailList}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" *ngIf="ticketStatusID == ticketStatusEnum['submitted'] && !isSupport ">
          <div class="cctoemail w500" [ngClass]="{'clickEmail':isClickEmail,'mousemoveEmail':isMousemoveEmail}"
          (click)="clickFunction()" (blur)="blurFunction()" (mousemove)="mousemoveFunction()"
            (mouseleave)="mouseleaveFunction()" tabindex="0">
             <nz-select class="w500 h100" nzMode="tags" nzPlaceHolder="{{'ticket.ccToEmial' | translate}}"
               formControlName="emailCC" [nzBorderless]="true">
               <nz-option *ngFor="let option of ccEmailList" [nzLabel]="option"
                [nzValue]="option"></nz-option>
               </nz-select>
             </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzSpan]="12" *ngIf="(ticketStatusID == ticketStatusEnum['create'] && isSupport) && !isAzureVDICategory()">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.problemSubCategory' | translate}}</mat-label>
            <mat-select formControlName="subCategoryID" required>
              <mat-option *ngFor="let option of problemSubCategoryList" [value]="option.id" (click)="changeProblemSubCategory();">
                {{lang == "en" ? option.subCategoryDescrEng : option.subCategoryDescrChi}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ticketForm.get('subCategoryID')?.hasError('required')">{{'input.subCategory' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" *ngIf="(ticketStatusID == ticketStatusEnum['create'] && isSupport) && isAzureVDICategory()">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>Problem Subategory</mat-label>
            <mat-select formControlName="subCategoryID" required>
              <mat-option *ngFor="let option of problemSubCategoryList" [value]="option.id" (click)="changeProblemSubCategory();">
                {{lang == "en" ? option.subCategoryDescrEng : option.subCategoryDescrChi}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ticketForm.get('subCategoryID')?.hasError('required')">{{'input.subCategory' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12"
          *ngIf="(ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport) && !isAzureVDICategory()">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.problemSubCategory' | translate}}</mat-label>
            <mat-select formControlName="subCategoryID" required [disabled]="true">
              <mat-option *ngFor="let option of problemSubCategoryList" [value]="option.id" (click)="changeProblemSubCategory();">
                {{lang == "en" ? option.subCategoryDescrEng : option.subCategoryDescrChi}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ticketForm.get('subCategoryID')?.hasError('required')">{{'input.subCategory' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12"
          *ngIf="(ticketStatusID == ticketStatusEnum['submitted'] ||ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport) && isAzureVDICategory()">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>Problem Subategory</mat-label>
            <mat-select formControlName="subCategoryID" required [disabled]="true">
              <mat-option *ngFor="let option of problemSubCategoryList" [value]="option.id" (click)="changeProblemSubCategory();">
                {{lang == "en" ? option.subCategoryDescrEng : option.subCategoryDescrChi}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ticketForm.get('subCategoryID')?.hasError('required')">{{'input.subCategory' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" *ngIf=" ticketStatusID != ticketStatusEnum['create'] && isSupport && !isShowLoading">
          <div class="labelName">{{'deviceInfo.title' | translate}}</div>
          <div class="labelContent">Platform = {{showDeviceInfo.Platform}};<br>Browser = {{showDeviceInfo.Browser}};<br>IP = {{showDeviceInfo.IP}};<br>Proxy = {{showDeviceInfo.Proxy}};<br>Login = {{showDeviceInfo.Login}}</div>
        </nz-form-control>

      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzSpan]="12"
          *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted']  && !isSupport || !isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) ">
          <div>
            <div nzTooltipTitle="{{fileName}}" nzTooltipPlacement="topLeft" nz-button nz-tooltip>
              <mat-form-field class="columns">
                <mat-label *ngIf="fileName; else newFile">{{fileName}}</mat-label>
                <ng-template #newFile>
                  <mat-label>{{'ticket.attachments' | translate}}</mat-label>
                </ng-template>
                <input matInput disabled>
                <button mat-icon-button matSuffix (click)="fileInput.click()">
                  <mat-icon>attach_file</mat-icon>
                </button>
                <input hidden (change)="import($event)" multiple #fileInput type="file" id="file">
              </mat-form-field>
            </div>
            <span>
              <nz-tag *ngFor="let file of fileList" nzMode="closeable" class="ml20 mb10"
                (nzOnClose)="deleteFiles(file)">
                <img nz-image width="100px" height="100px" [nzSrc]="file.showImage" alt=""
                  *ngIf="file.showImage && (file.fileMimeType == 'image/png' || file.fileMimeType == 'image/jpeg') " />
                <a *ngIf="file.fileMimeType == 'application/pdf'"
                  class="cursor" (click)="downloadFile(file.id, file.originalFileName)">{{file.originalFileName}}</a>
                <a *ngIf="!(file.fileMimeType == 'image/png' || file.fileMimeType == 'image/jpeg' || file.fileMimeType == 'application/pdf')"
                  class="cursor" (click)="downloadFile(file.id, file.originalFileName)">{{file.originalFileName}}</a>
              </nz-tag>
            </span>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="12"
          *ngIf="(ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport || (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) && isSupport) && !isShowLoading">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.attachments' | translate}}</div>
            <div class="labelContent">
              <div class="file">
                <div *ngFor="let file of fileList" class="mr20 mb10">
                  <div class="imgInfo"
                    *ngIf="file.showImage && (file.fileMimeType == 'image/png' || file.fileMimeType == 'image/jpeg') ">
                    <img class="cursor" nz-image width="80px" height="80px" [nzSrc]="file.showImage" alt="" />
                    <span class="cursor downloadText" nz-icon nzType="download" nzTheme="outline"
                      (click)="downloadFile(file.id,file.originalFileName)">{{'button.download' | translate }}</span>
                  </div>
                  <a class="cursor" (click)="downloadFile(file.id,file.originalFileName)"
                    *ngIf="!(file.fileMimeType == 'image/png' || file.fileMimeType == 'image/jpeg')">
                    {{file.originalFileName}}</a>
                </div>
              </div>
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item
        *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport  || !isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) ">
        <nz-form-control [nzSpan]="23">
          <mat-form-field class="fullWidth" appearance="fill">
            <mat-label>{{'ticket.description' | translate}} </mat-label>
            <textarea matInput formControlName="detail" required></textarea>
            <mat-error *ngIf="ticketForm.get('detail')?.hasError('required')">{{'input.description' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="(ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport || (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])  && isSupport) && !isShowLoading">
        <nz-form-control [nzSpan]="23">
          <div class="labelInfo">
            <div class="labelInfo">
              <div class="labelName">{{'ticket.description' | translate}}</div>
              <div class="labelContent">{{ticketForm.get('detail')?.value}}</div>
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>

  <!-- VDI Approval Status Section (only for VDI Setup tickets) -->
  <!-- <div class="vdiProvisioningInfo" *ngIf="isVDITicket() && ticketId">
    <div class="ticketTitle">
      VDI Approval Status
    </div>
    <div class="mt20">
      <app-vdi-approval-status
        [ticketId]="ticketId"
        [ticketNumber]="ticketNo"
        [autoRefresh]="ticketStatusID === ticketStatusEnum['submitted'] || ticketStatusID === ticketStatusEnum['inProgress']"
        (vmCreationCompleted)="onVmCreationCompleted($event)">
      </app-vdi-approval-status>
    </div>
  </div> -->

  <div class="vmDetailsInfo" *ngIf="isVmCreated">
    <div class="ticketTitle">
      VM Details
    </div>
    <div class="mt20" *ngIf="isVmDetailsLoading">
      <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
    </div>
    <form class="mt40" *ngIf="!isVmDetailsLoading && hasVmDetails()">
      <nz-form-item *ngFor="let detail of vmDetailEntries; trackBy: trackVmDetail">
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{ detail.key | titlecase }}</div>
            <div class="labelContent">
              <ng-container *ngIf="detail.isStructured; else vmDetailSimple">
                <pre class="vmDetailsPre">{{ detail.display }}</pre>
              </ng-container>
              <ng-template #vmDetailSimple>
                {{ detail.display }}
              </ng-template>
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
    <div class="mt20" *ngIf="!isVmDetailsLoading && !hasVmDetails() && !vmDetailsError">
      <div class="labelInfo">
        <div class="labelContent">No VM details available.</div>
      </div>
    </div>
    <div class="mt20" *ngIf="!isVmDetailsLoading && vmDetailsError">
      <div class="labelInfo">
        <div class="labelContent">{{ vmDetailsError }}</div>
      </div>
    </div>
  </div>

  <div class="resolutionInfo" *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel']">
    <div class="ticketTitle">
      {{'ticket.resolutionDetails' | translate}}
    </div>
    <form class="mt40" [formGroup]="ticketForm">
      <!-- <nz-form-item *ngIf="(ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel']) && !isShowLoading">
        <nz-form-control [nzSpan]="6">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.firstAcceptBy' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('firstAcceptedUser')?.value}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="6">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.firstAcceptDate' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('firstAcceptedDate')?.value | date:'dd/MM/yyyy HH:mm'}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="6">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.firstAssignedTeam' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('firstAssignedToTeamName')?.value}}</div>
          </div>
        </nz-form-control>
      </nz-form-item> -->
      <nz-form-item *ngIf="(ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel']) && !isShowLoading">
        <nz-form-control [nzSpan]="6">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.acceptBy' | translate}}</div>
            <div class="labelContent">{{ticketInfo?.acceptedByName || ticketInfo?.ticket?.acceptedBy}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="6">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.acceptDate' | translate}}</div>
            <div class="labelContent">{{ticketInfo?.ticket?.acceptedDate | date:'dd/MM/yyyy HH:mm'}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="6">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.assignedTeam' | translate}}</div>
            <div class="labelContent">{{ticketInfo?.ticket?.assignedToTeam?.name}}</div>
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="(ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel']) && !isShowLoading">
        <nz-form-control [nzSpan]="6">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.closedBy' | translate}}</div>
            <div class="labelContent">{{ticketInfo?.closedByName || ticketInfo?.ticket?.closedBy}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="6">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.closedDate' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('closedDate')?.value | date:'dd/MM/yyyy HH:mm'}}</div>
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzSpan]="12" *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.resolutionType' | translate}}</mat-label>
            <mat-select formControlName="resolutionTypeID" required>
              <mat-option *ngFor="let option of resolutionTypeList" [value]="option.id">
                {{lang == "en" ? option.resolutionTypeDescrEng : option.resolutionTypeDescrChi}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ticketForm.get('resolutionTypeID')?.hasError('required')">{{'input.resolutionType' |
              translate }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="6" *ngIf="(ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel']) && !isShowLoading">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.resolutionType' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('resolutionTypeName')?.value}}</div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="12" *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']">
          <mat-form-field class="w500" appearance="fill">
            <mat-label>{{'ticket.severityLevel' | translate}}</mat-label>
            <mat-select formControlName="severityLevel" required>
              <mat-option [value]="1">
                Level 1
              </mat-option>
              <mat-option [value]="2">
                Level 2
              </mat-option>
              <mat-option [value]="3">
                Level 3
              </mat-option>
              <mat-option [value]="4">
                Level 4
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ticketForm.get('severityLevel')?.hasError('required')">{{'input.severityLevel' | translate
              }}</mat-error>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="6" *ngIf="(ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel']) && !isShowLoading">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.severityLevel' | translate}}</div>
            <div class="labelContent">Level {{ticketForm.get('severityLevel')?.value}}</div>
          </div>

        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']">
        <nz-form-control [nzSpan]="23">
          <mat-form-field class="fullWidth" appearance="fill">
            <mat-label>{{'ticket.resolutionComments' | translate}}</mat-label>
            <textarea matInput formControlName="resolutionComments" required></textarea>
            <mat-error *ngIf="ticketForm.get('resolutionComments')?.hasError('required')">{{'input.resolutionComments' |
              translate}}</mat-error>
          </mat-form-field>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="(ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel']) && !isShowLoading">
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.resolutionComments' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('resolutionComments')?.value}}</div>
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
  <div class="resolutionInfo">
    <div class="ticketTitle">
      {{'ticket.remarkDetails' | translate}}
    </div>
    <form class="mt40" [formGroup]="remarkForm">
      <nz-form-item>
        <nz-form-control [nzSpan]="12">
          <div class="labelInfo" >
            <ul>
              <li *ngFor="let item of remarkList">
                <div class="userInfo">
                  <div>{{item.userAD}}</div>
                  <div>{{item.createdDate | date:'dd/MM/yyyy HH:mm'}}</div>
                </div>
                <div class="remarkInfo" [innerHTML]="item.remark  | linebreaks">
                </div>
            </li>
            </ul>
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzSpan]="12">
          <mat-form-field class="fullWidth" appearance="fill">
            <mat-label>{{'ticket.remarkComments' | translate}}</mat-label>
            <textarea matInput formControlName="remark"></textarea>
          </mat-form-field>
        </nz-form-control>
        <nz-form-control [nzSpan]="12">
          <button mat-raised-button color="primary" [disabled]="!remarkForm.get('remark')?.value" class="ml30 remark-submit-btn" (click)="addRemark()">{{'button.remark' | translate }}</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
  <div class="buttonInfo mb20" *ngIf="!isShowLoading">
    <button mat-raised-button color="primary"
      *ngIf="ticketStatusID == ticketStatusEnum['create'] || !isSupport && ticketStatusID == ticketStatusEnum['submitted'] || !isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])" class="mr20" (click)="saveForm()" [disabled]="isLoading">
      <span *ngIf="!isLoading">{{ (ticketStatusID == ticketStatusEnum['create'] ? 'button.submit' : 'button.save' ) | translate}}</span>
      <span *ngIf="isLoading" class="d-flex align-items-center">
        <nz-spin nzSimple [nzSize]="'small'" class="mr8"></nz-spin>
        {{ (ticketStatusID == ticketStatusEnum['create'] ? 'button.submit' : 'button.save' ) | translate}}...
      </span>
    </button>
    <!-- Cancel button - visible for users when ticket is submitted, inProgress or reassign -->
    <button mat-raised-button color="primary" *ngIf="(ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])" class="mr20" (click)="cancelForm()"
      >{{ 'button.cancelTicket' | translate}}</button>
    <!-- Approve button - shows when ticket status is inProgress or reassign and it's a VDI Create VM ticket -->
    <button mat-raised-button color="primary" class="mr20"
      *ngIf="(ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) && isVDICreateVmTicket()"
      [disabled]="isApprovingVdi || isCheckingApprovePermission || isApproveButtonDisabled || isApprovalStatusLoading"
      (click)="approveVdiTicket()">{{ approveButtonLabel }}</button>
    <!-- *ngIf="isSupport && (ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['reassign'])" -->
    <button mat-raised-button color="primary" *ngIf="ticketStatusID == ticketStatusEnum['submitted']" class="mr20"
      [disabled]="isLoading || ticketForm.get('subCategoryID')?.value == ''" (click)="acceptForm()">{{ 'button.accept' | translate}}</button>
    <button mat-raised-button color="primary" *ngIf="isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])" class="mr20" (click)="saveForm()">{{ 'button.save' |
      translate}}</button>
    <!-- *ngIf="isSupport && (ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])" -->
    <button mat-raised-button color="primary" [disabled]="isLoading || ticketForm.get('subCategoryID')?.value == ''" *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']" (click)="reassignTeam()" class="mr20">{{
        'button.reassign' | translate}}</button>
    <!-- Accept And Close button - visible for support when ticket is submitted (accepts and closes in one action) -->
    <button mat-raised-button color="primary" *ngIf="isSupport && ticketStatusID == ticketStatusEnum['submitted']"
      (click)="closeTicketForm()">{{ 'button.acceptAndColse' | translate}}</button>
    <!-- Close Ticket button - visible for support when ticket is inProgress or reassign -->
    <!-- Only requires resolutionTypeID to close, not the entire form -->
    <button mat-raised-button color="primary" *ngIf="isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])"
      [disabled]="!ticketForm.get('resolutionTypeID')?.value || isLoading"
      (click)="closeTicketForm()">{{ 'button.closeTicket' | translate}}</button>
    <button mat-raised-button color="primary" [ngClass]="{'align-right mr50':ticketStatusID !== ticketStatusEnum['closed'] && ticketStatusID !== ticketStatusEnum['cancel']}"
      (click)="back()" class="colorBack  "  >{{ 'button.back' | translate}}</button>
  <button mat-raised-button color="primary" (click)="createVm()" [disabled]="isButtonLoading || isCreateVmLoading" *ngIf="canShowCreateVmButton()" class="mr20" style="margin: 8px 20px;">
    <span *ngIf="!isCreateVmLoading">Create VM</span>
    <span *ngIf="isCreateVmLoading" class="d-flex align-items-center">
      <nz-spin nzSimple [nzSize]="'small'" class="mr8"></nz-spin>
      Creating VM...
    </span>
  </button>
    </div>
    
    <!-- Team Reassignment Dropdown - appears when reassign button is clicked -->
    <div class="team-reassignment-section" *ngIf="isReassignTeam" style="margin-top: 15px; padding: 15px; background-color: #f5f5f5; border-radius: 5px;">
      <div style="display: flex; align-items: center; gap: 15px;">
        <label style="font-weight: 500; color: #333;">{{'ticket.selectTeam' | translate}}</label>
        <mat-form-field appearance="fill" style="flex: 1; max-width: 400px;">
          <mat-label>{{'ticket.selectTeam' | translate}}</mat-label>
          <mat-select [(ngModel)]="assignedToTeamID" [ngModelOptions]="{standalone: true}" placeholder="{{'ticket.chooseTeam' | translate}}">
            <mat-option *ngFor="let team of assignedToTeamList" [value]="team.id">
              {{team.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="confirmReassign()" [disabled]="assignedToTeamID === 0">
          {{'button.confirmReassign' | translate}}
        </button>
        <button mat-raised-button (click)="cancelReassign()" style="background-color: #f0f0f0;">
          {{'button.cancel' | translate}}
        </button>
      </div>
      <div *ngIf="assignedToTeamList.length === 0" style="color: #666; font-size: 14px; margin-top: 10px;">
        {{'ticket.noTeamsAvailable' | translate}}
      </div>
      <div *ngIf="assignedToTeamList.length > 0 && assignedToTeamList[0].name?.includes('Fallback')" style="color: #ff9800; font-size: 14px; margin-top: 10px;">
        ⚠️ {{'ticket.usingFallbackTeams' | translate}}
      </div>
    </div>
</div>


<nz-modal [(nzVisible)]="isSubmitVisible" (nzOnCancel)="handleBack()" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin">{{ (!isSaveTicket ? 'popup.createTicket' : 'popup.saveTicket') | translate }}
    </p>
    <p class="smInfo textalgin">{{'popup.ticketNo' | translate }} - {{ticketNo}}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" (click)="handleBack()" class="mr20 colorBack">{{'button.backToTicket' |
      translate }}</button>
    <button mat-raised-button color="primary" (click)="handleOk()">{{'button.GoToInquiryList' | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isCancelVisible" (nzOnCancel)="handleBack()" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" *ngIf="!isClosed">{{'popup.questionToConfirmClose1' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="!isClosed">{{'popup.questionToConfirmClose3' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isClosed">{{'popup.ticketClose' | translate }}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button *ngIf="!isClosed" (click)="backToTicket()"
      class="mr20 colorBack">{{'button.cancel' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="!isClosed" [disabled]="isButtonLoading"
      (click)="handleCancelOk()">{{'button.confirm' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="isClosed" (click)="closeTicket()">{{'button.GoToInquiryList' |
      translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isShowAccept" (nzOnCancel)="isShowAccept = false" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin">{{'popup.acceptedTicket' | translate}}</p>
    <p class="smInfo textalgin">{{'popup.acceptedSentense' | translate}}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" (click)="backToTicket();" class="mr20 colorBack">{{'button.backToTicket' |
      translate }}</button>
    <button mat-raised-button color="primary" (click)="closeTicket()">{{'button.GoToInquiryList' | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isReassignTeam" (nzOnCancel)="isReassignTeam = false" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p *ngIf="!isReassignTicket" class="smInfo textalgin">{{'popup.ticketNo' | translate }} - {{ticketNo}}</p>
    <p *ngIf="!isReassignTicket" class="messageInfo textalgin">{{'popup.selectReassign' | translate }}</p>
    <mat-form-field class="fullWidth" appearance="fill" *ngIf="!isReassignTicket">
      <mat-label>{{'ticket.assignedTeam' | translate }} </mat-label>
      <mat-select [(ngModel)]="assignedToTeamID">
        <mat-option *ngFor="let option of assignedToTeamList" [value]="option.id">
          {{option.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <p class="messageInfo textalgin" *ngIf="isReassignTicket">{{ 'popup.reassignedTo' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isReassignTicket">{{assignedToTeamName}}</p>
    <p class="smInfo textalgin" *ngIf="isReassignTicket">{{'popup.ticketNo' | translate }}- {{ticketNo}} </p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary"  *ngIf="!isReassignTicket" (click)="backToTicket()" class="mr20 colorBack">{{'button.backToTicket' |
      translate }}</button>
    <button mat-raised-button color="primary"  *ngIf="!isReassignTicket" [disabled]="isButtonLoading" (click)="reassign()">{{'button.reassign' |
      translate }}</button>
    <button mat-raised-button color="primary"  *ngIf="isReassignTicket"  (click)="closeTicket()">{{'button.GoToInquiryList' |
      translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isShowChangeSubCategoryReassignLog" (nzOnCancel)="isShowChangeSubCategoryReassignLog = false" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" *ngIf="!isShowReassignTicket">{{'popup.reassignedMsg1' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="!isShowReassignTicket">{{'popup.reassignedMsg2' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isShowReassignTicket">{{ 'popup.reassignedTo' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isShowReassignTicket">{{assignedToTeamNameChangeSubCategory}}</p>
    <p class="smInfo textalgin" *ngIf="isShowReassignTicket">{{'popup.ticketNo' | translate }}- {{ticketNo}} </p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" *ngIf="!isShowReassignTicket" (click)="backToTicket()"
      class="mr20 colorBack">{{'button.backToTicket' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="!isShowReassignTicket" (click)="changeSubCategoryReassignOK();"
      [disabled]="isButtonLoading">{{'button.confirm' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="isShowReassignTicket" (click)="closeTicket()">{{'button.GoToInquiryList'
      | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isShowLog" nzWidth="800px" (nzOnCancel)="closeLog()" [nzClosable]="false">
  <div *nzModalContent>
    <div class="ticketTitle">
      <div class="back mr10" (click)="closeLog()">
        <div class="backInco"></div>
      </div>
      <div>{{'log.title' | translate}}</div>
    </div>
    <div class="logNO mt40">
      <div class="logTicket">{{'log.ticket' | translate }} </div>
      <div class="ml10 logTicketNO">{{ticketNo}}</div>
    </div>

    <nz-table appTableAdapt [nzFrontPagination]="false" #sortLogTable [nzData]="logListOfData" nzTableLayout="fixed"
      class="mt20">
      <thead>
        <tr>
          <th *ngFor="let column of listOfColumn">
            {{column.title}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of sortLogTable.data">
          <td>{{ data.createdDate | date:'dd/MM/yyyy HH:mm'}}</td>
          <td>{{ data.userAD }}</td>
          <td>{{ data.action }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <div *nzModalFooter>

  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isClosedVisible" (nzOnCancel)="isClosedVisible = false" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" *ngIf="!isClosedTicket">{{'popup.questionToConfirmClose1' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="!isClosedTicket">{{'popup.questionToConfirmClose2' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isClosedTicket">{{'popup.ConfirmClose' | translate }}</p>
    <p class="smInfo textalgin" *ngIf="isClosedTicket">{{'popup.ticketNo' | translate }}- {{ticketNo}} </p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button *ngIf="!isClosedTicket" (click)="backToTicket()"
      class="mr20 colorBack">{{'button.cancel' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="!isClosedTicket" (click)="handleClosedOk()"
      [disabled]="isButtonLoading">{{'button.confirm' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="isClosedTicket" (click)="closeTicket()">{{'button.GoToInquiryList'
      | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isShowPdf" nzWidth="1200px" (nzOnCancel)="isShowPdf = false" [nzClosable]="false">
  <div *nzModalContent>
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"
      style="width: 100%;height: 800px;"></pdf-viewer>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" class="mr20" (click)="isShowPdf = false">{{'button.back' | translate
      }}</button>
    <button mat-raised-button color="primary" *ngIf="isSupport"
      (click)="downloadFile(pdfId,pdfName)">{{'button.download' | translate }}</button>
  </div>
</nz-modal>


<nz-modal [(nzVisible)]="isBackConfirm"  [nzClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin">{{'popup.leave' | translate}}</p>
    <p class="smInfo textalgin">{{'popup.leaveSmall' | translate}}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" (click)="isBackConfirmClick = true; closeTicket();" class="mr20 colorBack">{{'button.leave' |
      translate }}</button>
    <button mat-raised-button color="primary" (click)="backToTicket();">{{'button.stay' | translate }}</button>
  </div>
</nz-modal>


<nz-modal [(nzVisible)]="isShowAcceptSubCategory" (nzOnCancel)="isShowAcceptSubCategory = false" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" >{{'popup.acceptMsg' | translate }}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary"  (click)="backToTicket()"
      class="mr20 colorBack">{{'button.backToTicket' | translate }}</button>
    <button mat-raised-button color="primary"  (click)="acceptFormChangeSubCategory()"
      [disabled]="isButtonLoading">{{'button.confirm' | translate }}</button>
  </div>
</nz-modal>


<nz-modal [(nzVisible)]="isHaveSupportTeamOperate" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" >{{'popup.supportTeamOperate' | translate }}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary"  (click)="backToTicketOperate()"
      class="mr20">{{'button.confirmTicket' | translate }}</button>
  </div>
</nz-modal>

<!-- VM Creation Warning Modal - appears during VM creation -->
<nz-modal [(nzVisible)]="isVmCreationInProgress" [nzClosable]="false" [nzMaskClosable]="false" nzWidth="550px" [nzStyle]="{ 'z-index': 9999 }">
  <div *nzModalContent>
    <div style="text-align: center; padding: 20px 10px;">
      <div style="margin-bottom: 20px;">
        <span style="font-size: 64px; animation: pulse 1.5s ease-in-out infinite;">⚠️</span>
      </div>
      <p class="messageInfo textalgin" style="font-size: 22px; font-weight: 600; margin-bottom: 15px; color: #d32f2f;">
        VM Creation in Progress
      </p>
      <p class="smInfo textalgin" style="font-size: 15px; line-height: 1.8; color: #555;">
        The VM creation process is currently running. <strong style="color: #d32f2f;">Please do not close this browser window or navigate away from this page.</strong><br><br>
        Closing the browser during this process may interrupt the VM creation and cause it to fail. The process will complete automatically in a minute.
      </p>
      <div style="margin-top: 25px; padding: 15px; background-color: #fff3cd; border-radius: 8px; border-left: 4px solid #ffc107;">
        <div style="display: flex; align-items: center; gap: 12px;">
          <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
          <span style="font-size: 14px; color: #856404;">Creating your virtual machine... Please wait.</span>
        </div>
      </div>
    </div>
  </div>
  <div *nzModalFooter>
  </div>
  <style>
    @keyframes pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.7; transform: scale(1.1); }
    }
  </style>
</nz-modal>


